<div class="fixed h-full w-full bg-pink-500 z-10" *ngIf="_isLoadingContent">
    loading...
</div>

<div *ngIf="_isLoadingContent" class="
    fixed z-10
    flex
    justify-center
    items-center
    h-full w-full
    bg-black
    ">
    <img src="https://jovdev-ws-02-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/loading-icon-01.png" class="
        relative
        animate-spin
        w-6 h-6
        ">
</div>

<div class="
    h-full w-full
    bg-black
    ">

    <full-app #_fullApp></full-app>
</div>

